import React from "react";
import Footer from "./components/Footer/footer";
import Layout from "./Layout";
import "./App.css";
import "./Resources/Fonts/commercial-type-1609-BRYCKB-web/1609-BRYCKB.css";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
function App() {
  const router = createBrowserRouter([
    {
      element: <Layout />,

      children: [{
          path: "/:langCode?",
          element: <Footer />
        }]
    }
  ])
  return (
    <RouterProvider router={router} />
    );
}

export default App;